/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimhomehealthcareplan extends IceEntity {
  claim_home_health_care_plan_key: string = "";
  discipline_type_code: string = "";
  total_visits_rendered: number = 0;
  total_visits_projected: number = 0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_HOME_HEALTH_CARE_PLAN";
  }
}

